"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.config = void 0;
var _userAnalyticsJs = _interopRequireDefault(require("@godaddy/user-analytics-js"));
var _eventMap = _interopRequireDefault(require("./eventMap"));
var _getEnvironment = require("./getEnvironment");
var isProd = (0, _getEnvironment.getEnvironment)() === _getEnvironment.Env.PROD;
var config = exports.config = {
  traffic2: {},
  fullstory: true,
  eventMap: _eventMap["default"],
  debug: !isProd
};
var eventLogger = (0, _userAnalyticsJs["default"])(config);
var _default = exports["default"] = eventLogger;